// ** MUI Imports
import { useEffect, useState } from "react";
import { createGenericContext } from "../utils/createGenericContext";
import MeDataService from "../services/MeService";
import { useLocation } from "react-router-dom";
import { LoadingSpinner } from "../components/loading";
import PatientInformationSheet from "../components/PatientInformationSheet";
import { anonymousPaths, isPathIn, optionalAuthPaths } from "./public-routes";

export interface IAuthContext {
  isLoggedIn: boolean;
}

const [useAuth, AuthContextProvider] = createGenericContext<IAuthContext>();

const AuthProvider = (props: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [pisAccepted, setPisAccepted] = useState<boolean>(true);
  const location = useLocation();

  const optionalAuth = isPathIn(location.pathname, optionalAuthPaths);

  useEffect(() => {
    if (isPathIn(location.pathname, anonymousPaths)) {
      setLoading(false)
      return;
    }
    else {
      setLoading(true)
    }

    MeDataService.me()
      .then((s) => {
        setIsLoggedIn(true);
        // Only false when the server explicitly says the patient must still accept the PIS.
        setPisAccepted(s.data?.pisAccepted !== false);
        setLoading(false);
      })
      .catch(() => {
        setIsLoggedIn(false);
        setLoading(false);

        if (optionalAuth) return;

        window.location.href = "/login";
      });
  }, [location.pathname, optionalAuth]);

  let contextValue = {
    isLoggedIn,
  };

  return (
    <AuthContextProvider value={contextValue}>
      {loading && <div style={{margin: "50% auto", textAlign:"center"}}><LoadingSpinner /></div>}
      {!loading && !pisAccepted && !optionalAuth && (
        <PatientInformationSheet onAccepted={() => setPisAccepted(true)} />
      )}
      {!loading && (pisAccepted || optionalAuth) && <>{props.children}</>}
    </AuthContextProvider>
  );
};

export { AuthProvider, useAuth };
